import React from 'react';
import Box from '@mui/material/Box';
import Topbar from '../../components/Topbar';

type MainProps = React.HTMLAttributes<HTMLDivElement>;

const Main: React.FunctionComponent<React.PropsWithChildren<MainProps>> = ({ children, className, ...rest }) => (
        <Box
                className={className}
                sx={(theme) => ({
                    paddingTop: theme?.settings?.appBar?.spacer(),
                    display: 'flex',
                    alignItems: 'stretch',
                    flexDirection: 'column',
                    flex: 1,
                })}
                {...rest}
        >
            <Topbar />
            <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'stretch',
                        flex: 1,
                    }}
            >
                {children}
            </Box>
        </Box>
);

export default Main;
